module.exports = __webpack_public_path__ + "img/detial_bg.99978a55.png";